﻿import {reactive, onBeforeMount, onMounted, onBeforeUnmount, watch, WatchStopHandle} from "vue";
import {usePageHost} from "./usePageHost";
import {useAunoa} from "./useAunoa";

export interface PageOptions {
    icon?: string;
    header?: string;
    mainClass?: any;
    disableHorizontalContentPadding?: boolean;
    disableBodyScrolling?: boolean;
    collapseHeader?: boolean;
    boxed?: boolean;
}

export const usePageOptions = (pageOptions?: PageOptions) => {

    const _pageOptions = reactive<PageOptions>({
        icon: undefined,
        header: undefined,
        disableHorizontalContentPadding: undefined,
        disableBodyScrolling: undefined,
        collapseHeader: undefined,
        boxed: undefined,
        ...pageOptions
    });

    const {setIsFluid} = useAunoa();

    onBeforeMount(() => {
        const {pageHost} = usePageHost();
        if (pageHost) {
            pageHost.mountOptions(_pageOptions);
            onBeforeUnmount(() => pageHost.unmountOptions());
        }
    });
    onMounted(() => {
        const stopHandle = watch(() => _pageOptions.boxed, boxed => setIsFluid(boxed === false), {immediate: true});
        onBeforeUnmount(stopHandle);
    });
    onBeforeUnmount(() => setIsFluid(false));

    return {
        page: _pageOptions
    }
}


